<div class="recent inset can-click" routerLink="/setpoints/summary">
  <div class="rag">
    <div class="r large-text">
      <i class="fa fa-circle fa-fw"></i>
      @if (totals()) {
        <span>{{ totals().red }}</span>
      } @else {
        <span> <i class="mdi mdi-spin-x2 mdi-loading"></i></span>
      }
    </div>
    <div class="a large-text">
      <i class="fa fa-circle fa-fw"></i>
      @if (totals()) {
        <span>{{ totals().amber }}</span>
      } @else {
        <span> <i class="mdi mdi-spin-x2 mdi-loading"></i></span>
      }
    </div>
    <div class="g large-text">
      <i class="fa fa-circle fa-fw"></i>
      @if (totals()) {
        <span>{{ totals().green }}</span>
      } @else {
        <span> <i class="mdi mdi-spin-x2 mdi-loading"></i></span>
      }
    </div>
  </div>
</div>
